import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { fluidType, device } from '../../../utils/helpers'
import MobileSubmenu from './MobileSubmenu'

const Wrapper = styled.ul`
  list-style: none;
  font-size: 23px;
  font-family: 'BarlowSemiBold';
  color: #fff;
  text-transform: uppercase;
  width: 100%;
  background: ${props => props.theme.color.bgDark};
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all .5s ease;
  position: fixed;
  top:80px;
  z-index: 1000000;

  @media ${device.tablet} {
    ${fluidType('480px', '1920px', '16px', '24px')};
    display: none;
  }
`

const ListItem = styled.li`
  padding: 15px 0;
  width: 100%;
  text-align: center;
  transition: all .5s ease;

  &:hover, &:active {
    background: ${props => props.theme.color.bgMedium};
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #fff;
`

const StyledLinkA = styled.a`
  text-decoration: none;
  color: #fff;
`

// Menu Item
const Item = ({ children, to, submenu, open, ...props }) => (
  <React.Fragment>
    <ListItem {...props}>
      {
        to.includes("noleggia") ?
          <StyledLink to={to}>{children}</StyledLink> :
          <StyledLinkA href={to}>{children}</StyledLinkA>
        }
    </ListItem>
    {submenu && (open && <MobileSubmenu items={submenu} />)}
  </React.Fragment>
)

const initialState = {
  noleggia: false,
  strutture: false
}

class MobileNav extends Component {
  state = {
    noleggia: false,
    strutture: false
  }

  toggleSubmenu (item) {
    this.setState({ ...initialState, [item]: !this.state[item] })
  }

  render () {
    const { items } = this.props
    return (
      <Wrapper>
        {items.map(item => {
          // if (item.submenu) {
          if (false) {
            return (
              <Item
                key={item.name}
                to={item.url}
                open={this.state[item.name.toLowerCase()]}
                onClick={this.toggleSubmenu.bind(this, item.name.toLowerCase())}
                submenu={item.submenu}
              >
                {item.name} <i className='fas fa-chevron-down fa-xs' />
              </Item>
            )
          } else {
            return (
              <Item key={item.name} to={item.url}>{item.name}</Item>
            )
          }
        })}
      </Wrapper>
    )
  }
}

export default MobileNav



// WEBPACK FOOTER //
// ./src/components/UI/Header/MobileNav.js